import React from 'react';
import styled from 'styled-components';

type TextComponentProps = {
  children: React.ReactNode
  size?: string
  weight?: string
  mb?: string
}

const TextStyle = styled.p<{size?: string, $weight: string, $mb?: string}>`
  color: #383432;
  font-size: ${props => props.size || '16px'};
  font-weight: ${props => props.$weight || 'normal'};
  margin: 0;
  margin-bottom: ${props => props.$mb || '0'};
`;

const Text: React.FC<TextComponentProps> = ({ children, size, weight, mb }) => {
  return (
    <TextStyle size={size} $weight={weight} $mb={mb}>
      { children }
    </TextStyle>
  );
};

export default Text;
